import React from 'react';
import { Typography, Paper } from '@mui/material';
import { Description } from '@mui/icons-material';
import ResponsivePage from '@/components/ResponsivePage';

const TranslateDocumentPage: React.FC = () => {
  return (
    <ResponsivePage
      alignItems="center"
      justifyContent="center"
      contentMaxWidth={600}
      sx={{
        bgcolor: 'white',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, sm: 3.5, md: 5 },
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          textAlign: 'center'
        }}
      >
        <Description sx={{ fontSize: { xs: 44, sm: 64, md: 80 }, color: 'primary.main', mb: { xs: 1.25, sm: 2 } }} />
        <Typography variant="h4" fontWeight={700} color="primary.main" gutterBottom sx={{ fontSize: { xs: '1.4rem', sm: '1.8rem', md: '2.125rem' } }}>
          Document Translation
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}>
          This feature is currently under development. Soon you'll be able to translate entire documents here!
        </Typography>
      </Paper>
    </ResponsivePage>
  );
};

export default TranslateDocumentPage;
